import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { DEGEN_DIFFICULTY } from '../../enum-registry.ts';

// DB 의 `degen_conditional_count_prob.difficulty` 는 DegenDifficulty
// (norns/jotnar/ragnarok) 멤버를 쓴다. `DegenConditionalPool.difficulty` 만
// ConditionalDifficulty (low/mid/high/extreme) 를 사용.
export const DegenConditionalCountProbSchema = defineSchema({
  name: 'serverDegenConditionalCountProb',
  fields: [
    ['difficulty', { kind: 'enum', name: 'DegenDifficulty', members: DEGEN_DIFFICULTY }],
    ['probabilities', { kind: 'array', of: 'number' }],
  ],
  lookupKeys: ['difficulty'],
});

export interface RawDegenConditionalCountProbRow {
  difficulty: string;
  probabilities: number[];
}

export function degenConditionalCountProbFromRaw(row: RawDegenConditionalCountProbRow) {
  return {
    difficulty: row.difficulty,
    probabilities: row.probabilities,
  };
}

registerCategorySchema('serverDegenConditionalCountProb', DegenConditionalCountProbSchema);
